// Currently turned off for all non-MMS stores
export const ACH_DENY_LIST = [
    "2550",
    "2551",
    "2552",
    "2570",
    "2580",
    "2650",
    "2750",
    "2770",
    "2771",
    "2772",
    "2790",
    "2791",
    "3001",
    "3002",
    "3003",
    "3004",
    "3006",
    "3007",
    "3008",
    "3009",
    "3010",
    "3011",
    "3012",
    "3013",
    "3014",
    "3015",
    "3016",
    "3017",
    "3018",
    "3019",
    "3020",
    "3021",
    "3022",
    "3023",
    "3024",
    "3025",
    "3026",
    "3027",
    "3028",
    "3029",
    "3030",
    "3031",
    "3032",
    "3033",
    "3034",
    "3035",
    "3037",
    "3101",
    "3102",
    "3103",
    "3104",
    "3105",
    "3106",
    "3107",
    "3201",
    "3202",
    "3203",
    "3204",
    "3205",
    "3301",
    "3302",
    "3303",
    "3304",
    "3305",
    "3306",
    "3307",
    "3308",
    "3309",
    "3310",
    "3311",
    "3401",
];
